import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=b2d623b2&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=ts"
export * from "./bulk.vue?vue&type=script&lang=ts"
import style0 from "./bulk.vue?vue&type=style&index=0&id=b2d623b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d623b2",
  null
  
)

export default component.exports